import React from 'react';
import classNames from 'classnames';
import './Badge.css';

export function Badge({ 
  children,
  variant = 'neutral',
  size = 'md',
  dot = false,
  className = '',
  ...props
}) {
  const badgeClasses = classNames(
    'agrisense-badge',
    `agrisense-badge--${variant}`,
    `agrisense-badge--${size}`,
    className
  );

  return (
    <span className={badgeClasses} {...props}>
      {dot && <span className="agrisense-badge__dot"></span>}
      {children}
    </span>
  );
}